document.addEventListener("DOMContentLoaded", () => {

  /* =========================================================
     CONFIGURAÇÕES
  ========================================================= */

  const STORAGE_SUBSCRIBED = "shopify_forms_subscribed";
  const COOKIE_BLOCKED = "shopify_forms_popup_blocked";

  /* ========================================================= 
      LIBERAR O SCROLL
   ========================================================= */ 
function liberarScroll() {

  setTimeout(() => {

    window.location.replace(window.location.href);

  }, 50);

}
  /* =========================================================
     ELEMENTOS
  ========================================================= */

  const popupOverlay = document.querySelector("#dr-popup-overlay");
  const couponOverlay = document.querySelector("#dr-coupon-overlay");

  const closePopupButton = document.querySelector("#dr-close-popup");
  const closeCouponButton = document.querySelector("#dr-coupon-close");

  const copyCouponButton = document.querySelector("#dr-copy-coupon");
  const couponCode = document.querySelector("#dr-coupon-code");

  /* =========================================================
     SHOPIFY FORMS
  ========================================================= */

const formsRoot =
document.querySelector(
'[data-forms-id="forms-root-782852"]'
)?.closest(".shopify-app-block");

  const formsContainer = document.querySelector(
    ".shopify-forms-container"
  );

  const originalFormsParent =
    formsRoot?.parentElement || null;

  let formsMoved = false;

  function moveShopifyForm() {

    if (!formsRoot)
      return;

    if (!formsContainer)
      return;

    if (formsMoved)
      return;

    formsContainer.appendChild(formsRoot);

    formsMoved = true;

  }

  function restoreShopifyForm() {

    if (!formsRoot)
      return;

    if (!originalFormsParent)
      return;

    originalFormsParent.appendChild(formsRoot);

    formsMoved = false;

  }

  /* =========================================================
     ESTADO
  ========================================================= */

let popupAberto = false;
let liberarCarrinho = false;

let ultimoBotaoClicado = null;
let ultimoFormulario = null;


  /* =========================================================
     COOKIES
  ========================================================= */

  function setCookie(name, value, hours) {

    const d = new Date();

    d.setTime(
      d.getTime() + hours * 60 * 60 * 1000
    );

    document.cookie =
      `${name}=${value};expires=${d.toUTCString()};path=/`;

  }

  function getCookie(name) {

    return document.cookie
      .split("; ")
      .find(c => c.startsWith(name + "="))
      ?.split("=")[1];

  }

function popupBloqueadoTemporariamente() {

  if (jaSeCadastrou())
    return true;

  return getCookie(COOKIE_BLOCKED) === "true";

}

function bloquearPopupPor1Dia() {

  setCookie(
    COOKIE_BLOCKED,
    "true",
    24
  );

}

  function jaSeCadastrou() {

    return (
      localStorage.getItem(
        STORAGE_SUBSCRIBED
      ) === "true"
    );

  }

  /* =========================================================
     POPUP
  ========================================================= */

  function abrirPopup() {

    if (!popupOverlay)
      return;

    popupAberto = true;

    moveShopifyForm();

    popupOverlay.classList.add("active");

document.documentElement.style.overflow = "hidden";
document.body.style.overflow = "hidden";

  }

  function fecharPopup() {

    document.documentElement.style.overflow = "";
document.body.style.overflow = "";

    if (!popupOverlay)
      return;

    popupAberto = false;

    popupOverlay.classList.remove("active");

    restoreShopifyForm();

if (!jaSeCadastrou()) {

  bloquearPopupPor1Dia();

}

    continuarAddToCart();

  }

  function abrirCupom() {

    if (!couponOverlay)
      return;

    popupAberto = false;

    popupOverlay.classList.remove("active");

    restoreShopifyForm();

    couponOverlay.classList.add("active");

document.documentElement.style.overflow = "hidden";
document.body.style.overflow = "hidden";

  }

  function fecharCupom() {

    document.documentElement.style.overflow = "";
document.body.style.overflow = "";

    if (!couponOverlay)
      return;

    couponOverlay.classList.remove("active");

    continuarAddToCart();

  }

  /* =========================================================
     CONTINUAR ADD TO CART
  ========================================================= */

async function continuarAddToCart() {

    if (!ultimoFormulario)
        return;

    if (!document.body.contains(ultimoFormulario)) {

        liberarCarrinho = false;
        ultimoBotaoClicado = null;
        ultimoFormulario = null;

        return;

    }

    liberarCarrinho = true;

    try {

        const formData = new FormData(ultimoFormulario);

        const response = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            headers: {
                Accept: "application/json"
            }
        });

        if (!response.ok) {

            throw new Error("Erro ao adicionar ao carrinho.");

        }

        /* Atualiza as seções do tema */

        document.dispatchEvent(
            new CustomEvent("cart:refresh")
        );

        /* Abre o drawer do XBoost caso exista */

        document.dispatchEvent(
            new CustomEvent("cart:open")
        );

        setTimeout(() => {

            window.location.reload();

        }, 500);

    } catch (err) {

        console.error(err);

    }

    liberarCarrinho = false;
    ultimoBotaoClicado = null;
    ultimoFormulario = null;

}

  /* =========================================================
     INTERCEPTA ADD TO CART
  ========================================================= */

  document.addEventListener(
    "click",
    e => {

      const btn =
        e.target.closest(
          'button[type="submit"][name="add"]'
        );

      if (!btn)
        return;

      ultimoBotaoClicado = btn;
      ultimoFormulario = btn.closest("form");

      if (liberarCarrinho)
        return;

      if (jaSeCadastrou())
        return;

      if (popupBloqueadoTemporariamente())
        return;

      if (popupAberto)
        return;

      e.preventDefault();
      e.stopImmediatePropagation();

      abrirPopup();

    },
    true
  );

  /* =========================================================
     FECHAR POPUPS
  ========================================================= */

  closePopupButton?.addEventListener(
    "click",
    fecharPopup
  );

  closeCouponButton?.addEventListener(
    "click",
    fecharCupom
  );

  popupOverlay?.addEventListener(
    "click",
    e => {

      if (e.target === popupOverlay) {

        fecharPopup();

      }

    }
  );

  couponOverlay?.addEventListener(
    "click",
    e => {

      if (e.target === couponOverlay) {

        fecharCupom();

      }

    }
  );

  /* =========================================================
     COPIAR CUPOM
  ========================================================= */

  copyCouponButton?.addEventListener(
    "click",
    async () => {

      const code =
        couponCode?.textContent.trim() ||
        "DIAS10";

      try {

        await navigator.clipboard.writeText(
          code
        );

      } catch {

        const input =
          document.createElement("input");

        input.value = code;

        document.body.appendChild(
          input
        );

        input.select();

        document.execCommand("copy");

        input.remove();

      }

      copyCouponButton.setAttribute(
        "aria-label",
        "Código copiado"
      );
      localStorage.setItem(
  STORAGE_SUBSCRIBED,
  "true"
);

setCookie(
  COOKIE_BLOCKED,
  "true",
  3650
);

    }
  );

  /* =========================================================
     SHOPIFY FORMS
  ========================================================= */

  document.addEventListener(
    "submit",
    e => {

      const form =
        e.target;

      if (

        form.closest(".shopify-forms-container") ||

        form.closest(
          "form[data-testid='form']"
        )

      ) {

        localStorage.setItem(
          STORAGE_SUBSCRIBED,
          "true"
        );

        setCookie(
  COOKIE_BLOCKED,
  "true",
  3650
);

        setTimeout(() => {

          abrirCupom();

        }, 800);

      }

    },
    true
  );

  /* =========================================================
     AGUARDA O SHOPIFY FORMS
  ========================================================= */

  const waitForms =
    setInterval(() => {

      if (
        document.querySelector(
          "[data-forms-id='forms-root-782852']"
        )
      ) {

        clearInterval(waitForms);

      }

    }, 200);

});
